/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAmbulanceSideView: {
  name: 'ambulance-side-view';
  data: string;
} = {
  name: 'ambulance-side-view',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 3a2 2 0 0 0-2 2v10a2 2 0 0 0 1.23 1.846 3 3 0 1 0 5.6.154H15c.058 0 .116-.003.173-.007a3 3 0 1 0 5.597-.146A2 2 0 0 0 22 15v-2.52a2 2 0 0 0-.75-1.561L17 7.519V5a2 2 0 0 0-2-2H4Zm14 12h2v-2.52l-3-2.4V15h1Zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM5 18a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm10-3H4V5h11v10ZM9 7a1 1 0 0 1 1 1v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 1 1-2 0v-1H7a1 1 0 1 1 0-2h1V8a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
